import React, { useState, useEffect } from 'react';  
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';  
import Header from './components/Header';  
import Footer from './components/Footer';  
import Watermark from './components/Watermark';  
import Loading from './components/Loading';  
import Home from './pages/Home';  
import Technology from './pages/Technology';  
import Developers from './pages/Developers';  
import Tokenomics from './pages/Tokenomics';
import Roadmap from './pages/Roadmap';
import Whitepaper from './pages/Whitepaper';

function App() {  
  const [isLoading, setIsLoading] = useState(true);  

  useEffect(() => {  
    const timer = setTimeout(() => {  
      setIsLoading(false);  
    }, 2000);  

    return () => clearTimeout(timer);  
  }, []);  

  if (isLoading) {  
    return <Loading />;  
  }  

  return (
    <Router>  
      <div className="flex flex-col min-h-screen bg-black relative">  
        <Header />  
        <main className="flex-grow bg-black">  
          <Routes>  
            <Route path="/" element={<Home />} />  
            <Route path="/technology" element={<Technology />} />  
            <Route path="/developers" element={<Developers />} />  
            <Route path="/tokenomics" element={<Tokenomics />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/whitepaper" element={<Whitepaper />} />
          </Routes>  
        </main>  
        <Footer />  
        <Watermark />  
      </div>  
    </Router>
  );  
}  

export default App;